import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Silence non-critical logs in production to avoid leaking sensitive data
if (process.env.NODE_ENV === 'production' && process.env.REACT_APP_ENABLE_LOGS !== 'true') {
  /* eslint-disable no-console */
  const noop = () => {};
  console.log = noop;
  console.debug = noop;
  console.info = noop;
  /* eslint-enable no-console */
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
